import { HeatmapWidgetEntity } from 'src/pages/dashboard/features/heatmap-widget/HeatmapWidget.entity';
import { parseHeatmapWidgetInternalState } from 'src/pages/dashboard/features/heatmap-widget/parseHeatmapWidget';

import type { TSerializedWidgetTemplate } from 'src/pages/dashboard/features/workspace/Workspace.store';

export function mapHeatmapTemplate(
  template: TSerializedWidgetTemplate,
  index: number,
  options?: { wellId: number | null }
): HeatmapWidgetEntity {
  const { size, position } = template;
  const internalState = parseHeatmapWidgetInternalState(template.internalState ?? {});

  const heatmapWidget = new HeatmapWidgetEntity(
    {
      wellId: options?.wellId ?? null,
      stateParams: internalState.stateParams ?? {},
      type: 'heatmap-widget',
    },
    {
      groupId: template.groupId || null,
      isGroupsDefaultOpened: false,
      uuid: template.uuid,
      isPinned: false,
      isFullscreen: false,
      zIndex: index + 1,
      size: {
        w: size.w,
        h: size.h,
      },
      position: {
        x: position.x,
        y: position.y,
      },
    }
  );

  return heatmapWidget;
}
